import { openQuickAdd } from '../store.js';
import { __ } from '../i18n.js';
import Icon from './Icon.jsx';

/**
 * WP-6: persistent capture entry point on home/category/manage (see
 * app.jsx's FAB_VISIBLE). Mounted inside .etm-app so it inherits the same
 * desktop containing-block confinement WP-2 set up for the bottom nav/
 * toast/modal overlay (.etm-pane-left .etm-app's transform) — "in the left
 * pane on desktop" falls out of that for free, no new plumbing needed.
 */
export default function QuickAddFab() {
  return (
    <button type="button" class="etm-fab" aria-label={__('Snel taak toevoegen', 'etm')} onClick={openQuickAdd}>
      <Icon name="add" size={28} />
    </button>
  );
}
